import React from 'react';
import { isIOS, isAndroid, isNative } from '../utils/platformUtils';
import PlatformLayout from './PlatformLayout';
import PlatformText from './PlatformText';
import PlatformSpinner from './PlatformSpinner';

const LoadingScreen = ({ 
  message = 'Loading...', 
  showSpinner = true, 
  size = 'large',
  variant = 'fullscreen',
  className = '',
  style = {}
}) => {
  const isNativePlatform = isNative();
  
  // Platform-specific styles
  const getContainerStyles = () => {
    const baseStyles = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: variant === 'fullscreen' ? '100vh' : '200px',
      padding: variant === 'fullscreen' ? '2rem' : '1rem',
      textAlign: 'center',
      ...style
    };

    if (isNativePlatform) {
      return {
        ...baseStyles,
        backgroundColor: isIOS() ? '#F2F2F7' : isAndroid() ? '#FAFAFA' : '#FFFFFF',
        color: isIOS() ? '#1C1C1E' : isAndroid() ? '#212121' : '#333333'
      };
    }

    return {
      ...baseStyles,
      backgroundColor: '#FFFFFF',
      color: '#333333'
    };
  };

  const getSpinnerContainerStyles = () => ({
    marginBottom: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  });

  const getMessageStyles = () => {
    const baseStyles = {
      fontSize: isNativePlatform ? (isIOS() ? '16px' : '14px') : '16px',
      fontWeight: isNativePlatform ? (isIOS() ? '500' : '400') : '400',
      color: isNativePlatform 
        ? (isIOS() ? '#8E8E93' : isAndroid() ? '#757575' : '#666666')
        : '#666666',
      margin: 0,
      lineHeight: 1.4
    };

    return baseStyles;
  };

  // For native platforms, use PlatformLayout wrapper
  if (isNativePlatform) {
    return (
      <PlatformLayout>
        <div style={getContainerStyles()} className={`loading-screen ${className}`}>
          {showSpinner && (
            <div style={getSpinnerContainerStyles()}>
              <PlatformSpinner 
                size={size} 
                color="primary"
              />
            </div>
          )}
          <PlatformText variant="body" style={getMessageStyles()}>
            {message}
          </PlatformText>
        </div>
      </PlatformLayout>
    );
  }

  // For web/PWA, render directly
  return (
    <div style={getContainerStyles()} className={`loading-screen ${className}`}>
      {showSpinner && (
        <div style={getSpinnerContainerStyles()}>
          <div 
            className="web-spinner"
            style={{
              width: size === 'small' ? '16px' : size === 'medium' ? '24px' : size === 'large' ? '32px' : '48px',
              height: size === 'small' ? '16px' : size === 'medium' ? '24px' : size === 'large' ? '32px' : '48px',
              border: `${size === 'large' || size === 'xlarge' ? '3px' : '2px'} solid #E0E0E0`,
              borderTop: `${size === 'large' || size === 'xlarge' ? '3px' : '2px'} solid #1976D2`,
              borderRadius: '50%',
              animation: 'webSpin 1s linear infinite'
            }}
          />
        </div>
      )}
      <p style={getMessageStyles()}>
        {message}
      </p>
    </div>
  );
};

export default LoadingScreen; 